import React, { useEffect, useState } from 'react';

const AmplitudeContext = React.createContext(null);

export const AmplitudeProvider = ({ children }) => {
  const AMPLITUDE_KEY  = "cac4aef22b5e837d7ba31f93384ce546";

  const [amplitude, setAmplitude] = useState();

  useEffect(() => {
    const amplitude = require('amplitude-js');
    const instance = amplitude.getInstance();

    instance.init(AMPLITUDE_KEY);

    setAmplitude(instance);
  }, [AMPLITUDE_KEY]);

  return (
    <AmplitudeContext.Provider value={amplitude}>
      {amplitude && children}
    </AmplitudeContext.Provider>
  );
};

export const AmplitudeConsumer = AmplitudeContext.Consumer;

export default AmplitudeContext;
